module.exports = __webpack_public_path__ + "static/media/28.732828e6.webp";